var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"100vh"},attrs:{"id":"app"}},[_c('TopNavbar'),_c('div',{staticClass:"container"},[_c('b-alert',{attrs:{"show":_vm.show_alert,"dismissible":""}},[_vm._v("Something went wrong"),_c('br'),_vm._v(_vm._s(_vm.error_msg))]),_c(_vm.main_component,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }